import { put, takeLatest } from 'redux-saga/effects';

import { requestBusinessUnit,requestCreateBusinessUnit } from '../../../services/BusinessUnit';
import { fetchBusinessUnitFailure, fetchBusinessUnitSuccess,
    createBusinessUnitSuccess, createBusinessUnitFailure } from '../../actions/BusinessUnit/businessunit-list';
import { FETCH_BUSINESS_UNIT_REQUEST ,CREATE_BUSINESS_UNIT_REQUEST} from '../../actions/BusinessUnit/types';

export function* watchBusinessUnit() {
    yield takeLatest(FETCH_BUSINESS_UNIT_REQUEST, FetchBusinessUnit);
  yield takeLatest(CREATE_BUSINESS_UNIT_REQUEST, createBusinessUnit);

}

/**
 * @typedef {Object} PAYLOAD
 * @property {number} skip
 *
 * @typedef {Object} PARAMS
 * @property {PAYLOAD} payload
 *
 */

/**
 *
 * @param {PARAMS} param0
 */
function* FetchBusinessUnit({ payload }) {
    try {
        const response = yield requestBusinessUnit(payload);
        yield put(fetchBusinessUnitSuccess(response));
    } catch (error) {
        yield put(
            fetchBusinessUnitFailure('Failed to get list of Business Unit')
        );
    }
}

function* createBusinessUnit({ payload }) {
    try {
      //service add
      const response = yield requestCreateBusinessUnit(payload);
      yield put(createBusinessUnitSuccess(response.data));
    } catch (error) {
      yield put(  createBusinessUnitFailure
        ('Failed to create Business Unit'));
    }
  }
